import { createContext } from 'react';

export interface ModalOptions {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  closeOnScrim?: boolean;
}

export interface ModalContextValue {
  openModal: (content: React.ReactNode, options?: ModalOptions) => void;
  closeModal: () => void;
}

export const ModalContext = createContext<ModalContextValue | null>(null);
